import { handleResponse, catchError } from './Response';
import { createApplicationRequest, createVerificationRequest } from './Request';

export function StartApplication(card, personalInfo, incomeExpenses, occupation, authUsers, application, offerCode) {
  const applicationRequest = createApplicationRequest(card, personalInfo, incomeExpenses, occupation, authUsers, application, offerCode);

  return fetch('/api/application/party',{
    method: 'POST', 
    body:JSON.stringify( applicationRequest ),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(handleResponse).then(json => {      
    return json;
  }).catch(catchError);
}

export function GetVerification() {
  return fetch('/api/application/verification',{
      method: 'GET', 
      credentials: 'include'
  }).then(handleResponse).then(json => {    
    return json;
  });
}

export function SubmitVerification(questions) {
  const verificationRequest = createVerificationRequest(questions);
  return fetch('/api/application/verification',{
      method: 'POST', 
      body:JSON.stringify( verificationRequest ),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      }
  }).then(handleResponse).then(json => {    
    return json;
  }).catch(catchError);
}

export function CompleteApplication() {
  return fetch('/api/application',{
      method: 'POST',
      credentials: 'include'
  }).then(handleResponse).then(json => {      
    return json;
  }).catch(catchError);
}

export function GetCards() {
  return fetch('/api/cards',{
      method: 'POST', 
      credentials: 'include'
  }).then(handleResponse).then(json => {      
    return json;
  }).catch(catchError);
}

export function GetVICards() {
  return fetch('/api/cards/vi',{
    method: 'POST',
    credentials: 'include'
  }).then(handleResponse).then(json => {
    return json;
  }).catch(catchError);
}

export function GetWelcomeOfferCards() {
  return fetch('/api/cards/welcomeOfferCards',{
    method: 'POST',
    credentials: 'include'
  }).then(handleResponse).then(json => {
    return json;
  }).catch(catchError);
}

export function GetIndustries() {
  return fetch('/Content/noc_mapping.json',{
    method: 'GET', 
    credentials: 'include'
  }).then(handleResponse).then(json => {      
    return json;
  }).catch(catchError);
}

export function GetUnoccupancyCodes() {
  return fetch('/Content/other_noc_mapping.json',{
    method: 'GET', 
    credentials: 'include'
  }).then(handleResponse).then(json => {      
    return json;
  }).catch(catchError);
}

export function KeepAlive() {
  return fetch('/api/state/refresh',{
    method: 'GET', 
    credentials: 'include'
  }).then(response => {      
    return response;
  }).catch(catchError);
}

export function GetAnalytics() {
  return fetch('/api/analytics',{
    method: 'POST', 
    credentials: 'include'
  }).then(handleResponse).then(json => {    
    return json;
  });
}


// WEBPACK FOOTER //
// ./src/utils/ApplicationApi.js